import BigNumber from 'bignumber.js';

export function formatGBP(value: number | string | BigNumber): string {
  const number = new BigNumber(value);
  const formattedNumber = number.toFixed(2);
  return `£${formattedNumber}`;
}
